import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/lib/motion";
import { STEPS } from "@/data/content";

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page" className="pt-20">
      <section className="border-b border-steel-border">
        <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
          <SectionHead
            overline="How It Works"
            title="Eight steps. No surprises."
            copy="Knowing what happens next removes most of the anxiety from tax season. Here is the entire process, start to finish."
          />
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-6 py-24 lg:px-10">
        {STEPS.map((s) => (
          <Reveal key={s.n} delay={0.05}>
            <div
              data-testid={`step-${s.n}`}
              className={`grid grid-cols-1 gap-6 border-b py-12 sm:grid-cols-12 ${
                s.highlight ? "border-steel-brass/60 bg-steel-surface/70 px-6 sm:px-10 my-4 shadow-[0_0_40px_rgba(168,85,247,0.14)]" : "border-dashed border-steel-border"
              }`}
            >
              <div className="sm:col-span-3">
                <span className={`font-mono text-5xl sm:text-6xl ${s.highlight ? "text-steel-brass" : "text-steel-muted/50"}`}>
                  {s.n}
                </span>
              </div>
              <div className="sm:col-span-9">
                {s.highlight && (
                  <span className="mb-3 inline-block border border-steel-brass/50 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-steel-brass">
                    The step that protects you
                  </span>
                )}
                <h3 className="font-display text-2xl font-medium text-steel-text sm:text-3xl">{s.title}</h3>
                <p className="mt-3 max-w-2xl text-base leading-relaxed text-steel-secondary">{s.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.1}>
          <p className="mt-12 max-w-3xl text-sm leading-relaxed text-steel-muted">
            The review-before-filing step is not a courtesy — it is the point. The IRS advises taxpayers
            never to sign a blank or incomplete return and to review it before signing. We build that review
            into every engagement.
          </p>
          <Link
            to="/get-started"
            data-testid="how-it-works-start-btn"
            className="group mt-10 inline-flex items-center gap-2 bg-steel-accent px-8 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-steel-accentHover"
          >
            Start Step 01
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
